import type { TweetResponseReferencedTweetTweetAuthorBasicInfo } from './tweetResponseReferencedTweetTweetAuthorBasicInfo';
import type { TweetResponseReferencedTweetTweetAuthorSocial } from './tweetResponseReferencedTweetTweetAuthorSocial';

/**
 * 트윗 작성자 정보
 */
export type TweetResponseReferencedTweetTweetAuthor = {
  /** 사용자 기본 정보 */
  basicInfo: TweetResponseReferencedTweetTweetAuthorBasicInfo;
  /** 소셜 관계 정보 */
  social?: TweetResponseReferencedTweetTweetAuthorSocial;
};
